import React from "react";
import {
  Alert,
  Box,
  Chip,
  MenuItem,
  Paper,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import { IMPORT_DESTINATION_FIELDS, IMPORT_FIELD_BY_VALUE } from "./importFields";

export default function ImportMappingStep({ headers, mapping, contract, onChange }) {
  const mappedValues = Object.values(mapping || {}).filter((value) => value && value !== "ignore");
  const nameMapped = mappedValues.includes("name");
  const backendFields = contract?.destinationFields;
  const supportedFields = backendFields && typeof backendFields === "object"
    ? IMPORT_DESTINATION_FIELDS.filter((field) => Boolean(backendFields[field.value]))
    : IMPORT_DESTINATION_FIELDS;

  return (
    <Stack spacing={2}>
      <Box>
        <Typography variant="h6" sx={{ fontWeight: 900 }}>Mapping de columnas</Typography>
        <Typography variant="body2" color="text.secondary">
          Elegí qué significa cada columna. Un campo WebProfit sólo puede usarse una vez y las opciones se limitan al contrato informado por el backend.
        </Typography>
      </Box>

      {!nameMapped ? <Alert severity="warning">Mapeá una columna a <strong>Nombre</strong> para continuar.</Alert> : null}
      <Alert severity="info">
        <strong>Stock</strong> se trata como stock inicial/a conciliar. No se guardará directo en Product; la confirmación deberá registrarlo mediante movimientos ERP.
      </Alert>

      <Stack spacing={1.25}>
        {headers.map((header) => {
          const selected = mapping?.[header] || "ignore";
          const definition = IMPORT_FIELD_BY_VALUE[selected];
          return (
            <Paper key={header} variant="outlined" sx={{ p: 1.5, borderRadius: 2.5 }}>
              <Stack direction={{ xs: "column", md: "row" }} spacing={1.5} alignItems={{ md: "center" }}>
                <Box sx={{ minWidth: { md: 210 }, flex: "0 0 32%" }}>
                  <Typography sx={{ fontWeight: 900 }}>{header}</Typography>
                  <Typography variant="caption" color="text.secondary">Columna de origen</Typography>
                </Box>
                <TextField
                  select
                  fullWidth
                  size="small"
                  label="Campo WebProfit"
                  value={selected}
                  onChange={(event) => onChange(header, event.target.value)}
                >
                  <MenuItem value="ignore">Ignorar</MenuItem>
                  {supportedFields.map((field) => {
                    const usedByOther = Object.entries(mapping || {}).some(
                      ([source, value]) => source !== header && value === field.value,
                    );
                    const backendLabel = backendFields?.[field.value]?.label;
                    return (
                      <MenuItem key={field.value} value={field.value} disabled={usedByOther}>
                        {backendLabel || field.label}{field.required ? " *" : ""}
                      </MenuItem>
                    );
                  })}
                </TextField>
                <Box sx={{ flex: "1 1 40%", minWidth: 0 }}>
                  {definition ? (
                    <Stack direction="row" spacing={1} alignItems="flex-start">
                      {definition.warning ? <Chip size="small" color="warning" label="ERP" /> : null}
                      <Typography variant="caption" color="text.secondary">{definition.description}</Typography>
                    </Stack>
                  ) : (
                    <Typography variant="caption" color="text.secondary">Esta columna no se importará.</Typography>
                  )}
                </Box>
              </Stack>
            </Paper>
          );
        })}
      </Stack>
    </Stack>
  );
}
